const de = {
    "key": "Translated Content",
    "loc_leaderboard": "Bestenliste",
    "loc_leaderboard_info": "Sammle <span>Punkte</span>. Je mehr Punkte du hast, desto besser die <span>Preise</span> ",
    "loc_see_discount": "Entdecke den Rabatt",
    "loc_turn_sound_off": "Lautstärke aus",
    "loc_turn_sound_on": "Lautstärke an",
    "loc_discount": "Rabatt",
    "loc_your_discounts": "Deine Rabatte",
    "loc_go_to_the_website": "Zu der Website",
    "loc_welcome": "Willkommen",
    "loc_what_is_your_name": "Wie ist dein Name?",
    "loc_incorect_name": "Ungültiger Name",
    "loc_map_screen": "Kartenansicht",
    "loc_go_back": "Zurück",
    "loc_tutorial": "Anleitung",
    "loc_next_tip": "Nächster Hinweis",
    "loc_phone_oriental": "Drehe dein Smartphone für ein noch besseres Spielerlebnis",
    "loc_pixi_pause": "Pause",
    "loc_pixi_pts": "Pkte",
    "loc_pixi_discount": "Rabatt",
    "loc_bg_release_tutorial_1": "Sammle drei identische Kacheln in einer Reihe und vertausche dabei benachbarte Kacheln",
    "loc_bg_release_tutorial_2": "Identische Kacheln öffnen den Hintergrund, befreie den gesamten Hintergrund, um das Level abzuschließen",
    "loc_drop_product_tutorial": "Bewegen Sie den Matte Ink nach unten, indem Sie Kacheln in eine Reihe bringen, um das Level zu beenden",
    "loc_fill_bar_tutorial": "Sammle Kacheln in einer Reihe, um den Balken zu füllen und das Level abzuschließen",
    "loc_lose_popup": "Level % fehlgeschlagen",
    "loc_win_popup": "Level % abgeschlossen",
    "loc_hello": "Hallo",
    "loc_start_game": "Spiel starten",
    "loc_oops": "Ups!",
    "loc_logic_popup_top": "Sieht aus als wärst du nicht angemeldet",
    "loc_logic_popup_bottom": "Melde dich an oder erstelle einen Account",
    "loc_ log_in": "Einloggen",
    "loc_tutorial_name_fillBar": "«Fülle den Balken» Modus",
    "loc_tutorial_name_background_release": "«Hintergrund befreien» Modus",
    "loc_tutorial_name_drop_product": "«Produkt runter bringen» Modus",
    "loc_loading": "Lädt",
    "loc_login_placeholder": "Name",
    "loc_play": "Level starten",
    "loc_level": "Level",
    "loc_create_account": "Erstelle einen Account",
    "loc_please_log_in": "Bitte einloggen",
    "loc_done": "Fertig!",
    "loc_try_again": "Erneut versuchen",
    "loc_you_win": "SIEG!",
    "loc_login": "Einloggen",
    "loc_login_info": "Sieht aus als wärst du nicht angemeldet",

    "loc_tiles_dropped": 'FLIESEN FALLEN GELASSEN',
    "loc_pixi_sec": 'sec',
    "loc_pixi_min": 'min',
    "loc_resume": 'FORTSETZEN',
    "loc_press_to_shuffle": "Drücken Sie, um zu mischen",
    "loc_comma": ','

};
export default de;
